import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  error: false,
  loading: true,
  wishlists: [],
  wishlistData: {},
  wishlistProducts: {
    products: [],
    error: false,
    loading: true,
  },
};

/**
 * Replace updated wishlist in wishlist list
 * @param wishlists
 * @param newWishlist
 * @returns {*}
 */
const replaceWishlist = (wishlists, newWishlist) =>
  wishlists.map((wishlist) => {
    if (wishlist.wishlistId === newWishlist.wishlistId) {
      return newWishlist;
    }

    return wishlist;
  });

/**
 * Add inventory quantity data to wishlist products data
 * @param productsDetails
 * @param inventoryData
 * @returns {*}
 */
const mapProductsForWishlist = ({ productsDetails, inventoryData }) =>
  productsDetails.map((product) => {
    const productInventoryData = inventoryData.find(({ pimSku }) => pimSku === product.itemskuId);
    return {
      ...product,
      quantity: productInventoryData?.quantity || 0,
    };
  });

export const wishlist = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENT_WISHLIST_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case actionTypes.CLIENT_WISHLIST_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    case actionTypes.CLIENT_GET_WISHLIST_LIST_SUCCESS: {
      return {
        ...state,
        wishlists: payload,
        loading: false,
      };
    }

    case actionTypes.CLIENT_GET_WISHLIST_SUCCESS: {
      return {
        ...state,
        wishlistData: payload,
        loading: false,
      };
    }

    case actionTypes.CLIENT_ADD_WISHLIST_SUCCESS: {
      return {
        ...state,
        wishlists: [...state.wishlists, payload],
        loading: false,
      };
    }

    case actionTypes.CLIENT_ADD_TO_WISHLIST_SUCCESS: {
      return {
        ...state,
        wishlists: replaceWishlist(state.wishlists, payload),
        loading: false,
      };
    }

    case actionTypes.CLIENT_GET_PRODUCTS_FOR_WISHLIST_LOADING: {
      return {
        ...state,
        wishlistProducts: {
          ...state.wishlistProducts,
          loading: true,
        },
      };
    }

    case actionTypes.CLIENT_GET_PRODUCTS_FOR_WISHLIST_ERROR: {
      return {
        ...state,
        wishlistProducts: {
          ...state.wishlistProducts,
          loading: false,
          error: true,
        },
      };
    }

    case actionTypes.CLIENT_GET_PRODUCTS_FOR_WISHLIST_SUCCESS: {
      return {
        ...state,
        wishlistProducts: {
          products: mapProductsForWishlist(payload),
          loading: false,
        },
      };
    }

    case actionTypes.CLIENT_RESET_WISHLIST_DATA: {
      return {
        ...state,
        wishlistData: {},
        wishlistProducts: {
          products: [],
          loading: false,
          error: false,
        },
      };
    }

    default:
      return state;
  }
};

export default wishlist;
